import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/servicesData";
import TechnologiesSection from "./components/TechnologiesSection";
import ContactSection from "./components/ContactSection";
import BusinessConsultingPage from "./services/BusinessConsultingPage";
import SoftwareDevelopmentPage from "./services/SoftwareDevelopmentPage";
import UXUIDesignPage from "./services/UXUIDesignPage";
import MobileAppDevelopmentPage from "./services/MobileAppDevelopmentPage";
import ITConsultingPage from "./services/ITConsultingPage";
import LandingPage from "./pages/Landing";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/huakar/services" element={<Services />} />
        <Route path="/huakar/tecnologias" element={<TechnologiesSection />} />
        <Route path="/huakar/contact" element={<ContactSection />} />
        <Route
          path="/huakar/services/business"
          element={<BusinessConsultingPage />}
        />
        <Route
          path="/huakar/services/software/development"
          element={<SoftwareDevelopmentPage />}
        />
        <Route
          path="/huakar/services/uxui-design"
          element={<UXUIDesignPage />}
        />
        <Route
          path="/huakar/services/mobile/development"
          element={<MobileAppDevelopmentPage />}
        />
        <Route
          path="/huakar/services/it/consulting"
          element={<ITConsultingPage />}
        />
      </Routes>
    </Router>
  );
}
export default App;
